import apiClient from '../utils/apiClient';

/**
 * Get all available permissions grouped by category
 */
export const getAllPermissions = async () => {
  try {
    const response = await apiClient.get('/api/permissions');
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err.message };
  }
};

/**
 * Get all available permissions grouped by category
 */
export const getPermissionsByCategory = async () => {
  try {
    const response = await apiClient.get('/api/permissions/by-category');
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err.message };
  }
};

/**
 * Get permissions for a specific user
 */
export const getUserPermissions = async (userId) => {
  try {
    const response = await apiClient.get(`/api/permissions/user/${userId}`);
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err.message };
  }
};

/**
 * Permission display names for UI
 */
export const PERMISSION_DISPLAY_NAMES = {
  // Leads
  'view_leads': 'View Leads',
  'create_leads': 'Create Leads',
  'edit_leads': 'Edit Leads',
  'delete_leads': 'Delete Leads',
  
  // Projects
  'view_projects': 'View Projects',
  'create_projects': 'Create Projects',
  'edit_projects': 'Edit Projects',
  'delete_projects': 'Delete Projects',
  'manage_project_team': 'Manage Project Team',
  'view_project_budgets': 'View Project Budgets',
  'manage_project_budgets': 'Manage Project Budgets',
  
  // People
  'view_people': 'View People',
  'invite_people': 'Invite People',
  'edit_people': 'Edit People',
  'delete_people': 'Delete People',
  
  // Schedule
  'view_schedule': 'View Team Schedule',
  'view_own_schedule': 'View Own Schedule',
  'create_bookings': 'Create Bookings',
  'edit_bookings': 'Edit Bookings',
  'delete_bookings': 'Delete Bookings',
  'view_all_schedules': 'View All Schedules',
  
  // Timesheets
  'view_timesheets': 'View All Timesheets',
  'view_own_timesheets': 'View Own Timesheets',
  'create_timesheets': 'Create Timesheets',
  'edit_timesheets': 'Edit Timesheets',
  'delete_timesheets': 'Delete Timesheets',
  'approve_timesheets': 'Approve Timesheets',
  
  // Profile
  'view_own_profile': 'View Own Profile',
  'edit_own_profile': 'Edit Own Profile',
  
  // Settings
  'manage_company_settings': 'Manage Company Settings'
};

/**
 * Get display name for a permission
 */
export const getPermissionDisplayName = (permission) => {
  return PERMISSION_DISPLAY_NAMES[permission] || permission;
};

/**
 * Permission categories for organizing in UI
 */
export const PERMISSION_CATEGORIES = {
  leads: 'Leads',
  projects: 'Projects',
  people: 'People',
  schedule: 'Schedule',
  timesheets: 'Timesheets',
  profile: 'Profile',
  settings: 'Settings'
};

/**
 * Get category display name
 */
export const getCategoryDisplayName = (category) => {
  return PERMISSION_CATEGORIES[category] || category;
};

const permissionService = {
  getAllPermissions,
  getUserPermissions,
  getPermissionDisplayName,
  getCategoryDisplayName
};
export default permissionService;